import { Product } from '../schemas';

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 'prod-iphone-16-pro-128',
    slug: 'apple-iphone-16-pro-128gb-titanium',
    title: 'Apple iPhone 16 Pro 128GB Titanium Desbloqueado',
    brand: 'Apple',
    category: 'smartphones',
    subcategory: 'iOS',
    model: 'A3293',
    mpn: 'MYNE3LL/A',
    ean: '0195949789012',
    description: 'Diseño en titanio de grado aeroespacial, Chip A18 Pro con GPU de 6 núcleos, Control de Cámara dedicado y grabación 4K 120 fps en Dolby Vision.',
    images: [
      'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=600&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?w=600&auto=format&fit=crop&q=80',
    ],
    thumbnail: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=400&auto=format&fit=crop&q=80',
    specifications: {
      'Pantalla': '6.3" Super Retina XDR OLED 120Hz',
      'Procesador': 'Apple A18 Pro Bionic',
      'Almacenamiento': '128 GB NVMe',
      'Cámara Principal': '48 MP + 48 MP Ultra Wide + 12 MP Teleobjetivo 5x',
      'Batería': 'Hasta 27 horas de video',
      'Conectividad': '5G, Wi-Fi 7, USB-C 3.2 Gen 2 (10Gbps)',
    },
    bestPriceUSD: 940.0,
    highestPriceUSD: 1010.0,
    bestStoreId: 'nissei',
    offersCount: 4,
    offers: [
      {
        storeId: 'nissei',
        storeName: 'Casa Nissei',
        priceUSD: 940.0,
        originalPriceUSD: 999.0,
        discountPercentage: 6,
        stockStatus: 'in_stock',
        stockQuantity: 28,
        productUrl: 'https://nissei.com/py/apple-iphone-16-pro-128gb-titanium',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'cellshop',
        storeName: 'Cellshop Importados',
        priceUSD: 955.0,
        stockStatus: 'in_stock',
        stockQuantity: 15,
        productUrl: 'https://cellshop.com/apple-iphone-16-pro-128gb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'mega_eletronicos',
        storeName: 'Mega Eletrônicos',
        priceUSD: 965.0,
        stockStatus: 'in_stock',
        stockQuantity: 8,
        productUrl: 'https://megaeletronicos.com/iphone-16-pro-128gb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'shopping_china',
        storeName: 'Shopping China',
        priceUSD: 1010.0,
        stockStatus: 'in_stock',
        stockQuantity: 40,
        productUrl: 'https://shoppingchina.com.py/iphone-16-pro',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
    ],
    arcaCategory: 'tech_electronics',
    rating: 4.9,
    reviewsCount: 312,
    isFeatured: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'prod-macbook-air-m3-13-256',
    slug: 'apple-macbook-air-13-m3-8gb-256gb-space-gray',
    title: 'Apple MacBook Air 13" M3 8-Core CPU 8GB 256GB SSD',
    brand: 'Apple',
    category: 'informatica',
    subcategory: 'Notebooks',
    model: 'MRXV3LL/A',
    mpn: 'MRXV3LL/A',
    ean: '0195949123890',
    description: 'Increíblemente delgada y rápida con el chip M3 de Apple. Hasta 18 horas de batería, pantalla Liquid Retina y compatibilidad con hasta dos monitores externos.',
    images: [
      'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=600&auto=format&fit=crop&q=80',
    ],
    thumbnail: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400&auto=format&fit=crop&q=80',
    specifications: {
      'Pantalla': '13.6" Liquid Retina LED (2560 x 1664)',
      'Procesador': 'Apple M3 8-Core (4 rendimiento + 4 eficiencia)',
      'Memoria RAM': '8 GB Unificada',
      'Almacenamiento': '256 GB SSD ultrarrápido',
      'Batería': '52.6 Wh (Hasta 18 horas)',
      'Peso': '1.24 kg',
    },
    bestPriceUSD: 899.0,
    highestPriceUSD: 975.0,
    bestStoreId: 'topdek',
    offersCount: 3,
    offers: [
      {
        storeId: 'topdek',
        storeName: 'Topdek Informática',
        priceUSD: 899.0,
        originalPriceUSD: 949.0,
        discountPercentage: 5,
        stockStatus: 'in_stock',
        productUrl: 'https://topdek.com.py/macbook-air-m3-13-256gb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'nissei',
        storeName: 'Casa Nissei',
        priceUSD: 920.0,
        stockStatus: 'in_stock',
        productUrl: 'https://nissei.com/py/macbook-air-m3-13-256',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'cellshop',
        storeName: 'Cellshop Importados',
        priceUSD: 975.0,
        stockStatus: 'in_stock',
        productUrl: 'https://cellshop.com/macbook-air-m3',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
    ],
    arcaCategory: 'tech_electronics',
    rating: 4.8,
    reviewsCount: 89,
    isFeatured: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'prod-playstation-5-slim-1tb',
    slug: 'sony-playstation-5-slim-1tb-digital-edition',
    title: 'Sony PlayStation 5 Slim 1TB Edición Estándar con Lector',
    brand: 'Sony',
    category: 'consolas_gaming',
    subcategory: 'Consolas',
    model: 'CFI-2000',
    description: 'Consola PS5 Slim más compacta con 1TB de almacenamiento SSD, tecnología Tempest 3D AudioTech y gatillos adaptativos en el mando DualSense.',
    images: [
      'https://images.unsplash.com/photo-1606813907291-d86efa9b94db?w=600&auto=format&fit=crop&q=80',
    ],
    thumbnail: 'https://images.unsplash.com/photo-1606813907291-d86efa9b94db?w=400&auto=format&fit=crop&q=80',
    specifications: {
      'Almacenamiento': 'SSD 1TB personalizado (5.5 GB/s)',
      'Resolución': 'Hasta 4K 120Hz / Soporte 8K HDR',
      'Unidad Óptica': 'Ultra HD Blu-ray Disc Drive',
      'Audio': 'Tempest 3D AudioTech',
    },
    bestPriceUSD: 465.0,
    highestPriceUSD: 510.0,
    bestStoreId: 'atacado_games',
    offersCount: 3,
    offers: [
      {
        storeId: 'atacado_games',
        storeName: 'Atacado Games',
        priceUSD: 465.0,
        originalPriceUSD: 499.0,
        discountPercentage: 7,
        stockStatus: 'in_stock',
        productUrl: 'https://atacadogames.com/playstation-5-slim-1tb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'cellshop',
        storeName: 'Cellshop Importados',
        priceUSD: 480.0,
        stockStatus: 'in_stock',
        productUrl: 'https://cellshop.com/ps5-slim-1tb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'shopping_china',
        storeName: 'Shopping China',
        priceUSD: 510.0,
        stockStatus: 'in_stock',
        productUrl: 'https://shoppingchina.com.py/ps5-slim',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
    ],
    arcaCategory: 'tech_electronics',
    rating: 4.9,
    reviewsCount: 420,
    isFeatured: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'prod-sony-wh1000xm5-black',
    slug: 'sony-wh-1000xm5-noise-cancelling-headphones-black',
    title: 'Sony WH-1000XM5 Auriculares Bluetooth con Cancelación de Ruido',
    brand: 'Sony',
    category: 'audio_tv',
    subcategory: 'Auriculares',
    description: 'La mejor cancelación de ruido del mercado con 8 micrófonos y procesador V1 + QN1. Hasta 30 horas de reproducción de alta fidelidad LDAC.',
    images: [
      'https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=600&auto=format&fit=crop&q=80',
    ],
    thumbnail: 'https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=400&auto=format&fit=crop&q=80',
    specifications: {
      'Cancelación de Ruido': 'Auto NC Optimizer con doble procesador HD QN1',
      'Batería': '30 horas (Carga rápida: 3 min = 3 horas)',
      'Códecs': 'LDAC, AAC, SBC, Hi-Res Audio Wireless',
      'Peso': '250 gramos',
    },
    bestPriceUSD: 275.0,
    highestPriceUSD: 320.0,
    bestStoreId: 'madrid_center',
    offersCount: 3,
    offers: [
      {
        storeId: 'madrid_center',
        storeName: 'Madrid Center',
        priceUSD: 275.0,
        stockStatus: 'in_stock',
        productUrl: 'https://madridcenter.com/sony-wh-1000xm5',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'nissei',
        storeName: 'Casa Nissei',
        priceUSD: 289.0,
        stockStatus: 'in_stock',
        productUrl: 'https://nissei.com/py/sony-wh-1000xm5',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'cellshop',
        storeName: 'Cellshop Importados',
        priceUSD: 320.0,
        stockStatus: 'in_stock',
        productUrl: 'https://cellshop.com/sony-wh-1000xm5',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
    ],
    arcaCategory: 'tech_electronics',
    rating: 4.8,
    reviewsCount: 154,
    isFeatured: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'prod-dior-sauvage-elixir-60ml',
    slug: 'dior-sauvage-elixir-parfum-60ml',
    title: 'Dior Sauvage Elixir Parfum Concentrado 60ml',
    brand: 'Dior',
    category: 'perfumeria_belleza',
    subcategory: 'Perfumes Hombre',
    description: 'Un perfume extraordinariamente concentrado impregnado de la emblemática frescura de Sauvage con un corazón embriagador de especias y lavanda.',
    images: [
      'https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=600&auto=format&fit=crop&q=80',
    ],
    thumbnail: 'https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=400&auto=format&fit=crop&q=80',
    specifications: {
      'Volumen': '60 ml / 2.0 fl. oz',
      'Concentración': 'Elixir / Parfum Extrait',
      'Notas': 'Pomelo, Canela, Nuez Moscada, Cardamomo, Lavanda, Ámbar, Pachulí',
      'Origen': 'Francia (100% Original Sellado)',
    },
    bestPriceUSD: 142.0,
    highestPriceUSD: 175.0,
    bestStoreId: 'elegancia_company',
    offersCount: 3,
    offers: [
      {
        storeId: 'elegancia_company',
        storeName: 'Elegancia Company',
        priceUSD: 142.0,
        originalPriceUSD: 160.0,
        discountPercentage: 11,
        stockStatus: 'in_stock',
        productUrl: 'https://eleganciacompany.com.py/dior-sauvage-elixir-60ml',
        warrantyMonths: 0,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'shopping_china',
        storeName: 'Shopping China',
        priceUSD: 155.0,
        stockStatus: 'in_stock',
        productUrl: 'https://shoppingchina.com.py/dior-sauvage-elixir',
        warrantyMonths: 0,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'cellshop',
        storeName: 'Cellshop Importados',
        priceUSD: 175.0,
        stockStatus: 'in_stock',
        productUrl: 'https://cellshop.com/sauvage-elixir-60ml',
        warrantyMonths: 0,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
    ],
    arcaCategory: 'perfume_cosmetics',
    rating: 5.0,
    reviewsCount: 98,
    isFeatured: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'prod-samsung-galaxy-s24-ultra-256',
    slug: 'samsung-galaxy-s24-ultra-5g-256gb-titanium-gray',
    title: 'Samsung Galaxy S24 Ultra 5G 256GB Titanium Gray',
    brand: 'Samsung',
    category: 'smartphones',
    subcategory: 'Android',
    description: 'Galaxy AI incorporado, marco de titanio, pantalla plana Dynamic AMOLED 2X de 6.8 pulgadas con Corning Gorilla Armor antirreflejo y S Pen integrado.',
    images: [
      'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=600&auto=format&fit=crop&q=80',
    ],
    thumbnail: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=400&auto=format&fit=crop&q=80',
    specifications: {
      'Pantalla': '6.8" Dynamic AMOLED 2X QHD+ 120Hz 2600 nits',
      'Procesador': 'Snapdragon 8 Gen 3 for Galaxy (4nm)',
      'Memoria RAM': '12 GB LPDDR5X',
      'Almacenamiento': '256 GB UFS 4.0',
      'Cámara': '200 MP + 50 MP (5x) + 10 MP (3x) + 12 MP Ultra Wide',
      'Batería': '5000 mAh con carga de 45W',
    },
    bestPriceUSD: 870.0,
    highestPriceUSD: 940.0,
    bestStoreId: 'mobile_zone',
    offersCount: 3,
    offers: [
      {
        storeId: 'mobile_zone',
        storeName: 'Mobile Zone',
        priceUSD: 870.0,
        originalPriceUSD: 920.0,
        discountPercentage: 5,
        stockStatus: 'in_stock',
        productUrl: 'https://mobilezone.com.py/samsung-s24-ultra-256gb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'nissei',
        storeName: 'Casa Nissei',
        priceUSD: 885.0,
        stockStatus: 'in_stock',
        productUrl: 'https://nissei.com/py/samsung-s24-ultra',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
      {
        storeId: 'cellshop',
        storeName: 'Cellshop Importados',
        priceUSD: 940.0,
        stockStatus: 'in_stock',
        productUrl: 'https://cellshop.com/s24-ultra-256gb',
        warrantyMonths: 12,
        paymentMethodsSupported: ['CASH_USD', 'PIX', 'CREDIT_CARD'],
        lastChecked: new Date().toISOString(),
      },
    ],
    arcaCategory: 'tech_electronics',
    rating: 4.8,
    reviewsCount: 165,
    isFeatured: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
